import React, { useCallback } from 'react';
import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { actions } from '../../../context';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { reset } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

const colBreakpoints = { lg: '3', md: '6', sm: '12', xs: '12' };
const tabClasses = 'd-flex justify-content-between hoverable unselectable sc-rounded sc-glass';
const closeButtonClassses = 'd-inline p-2 text-secondary hoverable tab-close';

function PracticeTab({ practiceName, practiceId, tabIndex, url }) {
    const dispatch = useDispatch();
    let history = useHistory();

    const tabsLength = useSelector((state) => state.practice.selectedPracticeTabs.length);

    // TODO: circle back to this after the refactor because this is super slow right now
    const closeTabHandler = useCallback((practiceId, tabIndex) => {
        let practice = {id:practiceId};
        dispatch(actions.practice.closePracticeTab(practice, tabIndex));
        // TODO: IDK if this reset function targets a form that we still use
        dispatch(reset('editPracticeDataForm'));
        if (tabsLength <= 1) {
            //closing last tab
            return history.push('/'); //go to home page
        }
    }, [dispatch, history, tabsLength]);
    
    const closeTab = useCallback(
        () => closeTabHandler(practiceId, tabIndex),
        [practiceId, tabIndex, closeTabHandler]
    );

    const isTabSelected = url.includes(practiceId);

    return (
        <Col {...colBreakpoints} title={practiceName} className="p-1">
            <div
                className={classNames(tabClasses, {
                    'bg-light text-dark': isTabSelected,
                })}>
                <Link
                    className="w-100 text-center p-2 hide-overflow"
                    to={`/practices/${practiceId}`}
                    style={{
                        textDecoration: 'none',
                        color: isTabSelected ? 'black' : 'white',
                    }}>
                    <div className="d-inline hide-overflow">
                        {practiceName || 'Unknown Practice'}
                    </div>
                </Link>
                <div className={closeButtonClassses} onClick={closeTab}>
                    <FontAwesomeIcon icon={faTimes} size="lg" />
                </div>
            </div>
        </Col>
    );
}

export default PracticeTab;
